import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action'
import { ActionArgs } from '../../action'

@InputType()
export class GetaShipEnginePackageLabelArgs extends ActionArgs {
  @Field(() => String)
  labelId: string
}

@InputType()
export class GetShipEnginePackageLabelResult extends ActionArgs {
  @Field(() => Number)
  package_id: number

  @Field(() => String)
  pdf: string

  @Field(() => String)
  png: string

  @Field(() => String)
  zpl: string
}

export interface IGetShipEnginePackageLabel extends IAction<
  GetShipEnginePackageLabelResult[],
  GetaShipEnginePackageLabelArgs
> {}
